import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DebounceinputComponent } from './debounceinput.component';

const routes: Routes = [
  { path: '', component: DebounceinputComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DebounceinputRoutingModule { }
